(() => {
  if (window.njtFrontReady) return;
  window.njtFrontReady = true;
  const vehicleKey = 'filter.p.m.organizer.car_models';
  const previewKeys = ['preview_theme_id', '_fd', 'pb'];
  const saved = () => { try { return JSON.parse(localStorage.getItem('gta-global-vehicle-filter') || 'null'); } catch (_) { return null; } };
  const currentVehicle = () => new URL(location.href).searchParams.get(vehicleKey) || (location.pathname.includes('/collections/') ? '' : saved()?.vehicleName || '');
  const vehicles = () => [...document.querySelectorAll('#njh-vehicles [data-njh-vehicle]')];
  const route = (href, vehicle = currentVehicle()) => {
    const target = new URL(href, location.origin), current = new URL(location.href);
    if (target.origin !== location.origin) return target;
    for (const key of [...target.searchParams.keys()]) if (key.startsWith('filter.') || key.startsWith('njt_') || key === 'page' || key === 'sort_by') target.searchParams.delete(key);
    if (vehicle && target.pathname.includes('/collections/')) target.searchParams.set(vehicleKey, vehicle);
    previewKeys.forEach(key => { if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key)); });
    return target;
  };
  const sync = () => {
    const name = currentVehicle(), selected = vehicles().find(v => v.dataset.vehicleName === name);
    const title = selected?.dataset.vehicleTitle || saved()?.vehicleTitleOverwrite || name;
    document.querySelectorAll('[data-njh-selected-image]').forEach(image => { const src = selected?.querySelector('img')?.getAttribute('src'); image.hidden = !src || !name; if (src) { image.src = src; image.alt = title; } else image.removeAttribute('src'); });
    document.querySelectorAll('[data-njh-current-title]').forEach(node => node.textContent = title);
    document.querySelectorAll('[data-njh-current], [data-njh-home-selected]').forEach(node => node.hidden = !name);
    document.querySelectorAll('[data-njh-finder]').forEach(node => node.hidden = Boolean(name));
    document.querySelectorAll('[data-njh-route]').forEach(link => { link.dataset.njhBase ||= link.getAttribute('href'); link.href = route(link.dataset.njhBase); });
  };
  const choose = async (link) => {
    if (!link || link.dataset.busy) return;
    link.dataset.busy = 'true';
    link.setAttribute('aria-busy', 'true');
    const d = link.dataset;
    const vehicle = { vehicleName: d.vehicleName, vehicleTitleOverwrite: d.vehicleTitle, vehicleMake: d.vehicleMake, vehicleModel: d.vehicleModel, vehicleCollectionHandle: d.vehicleHandle, vehicleImage: link.querySelector('img')?.src || '' };
    try {
      if (window.globalVehicleFilter?.setFilter) window.globalVehicleFilter.setFilter(vehicle, false);
      else { try { localStorage.setItem('gta-global-vehicle-filter', JSON.stringify(vehicle)); } catch (_) {} }
      const current = new URL(location.href);
      if (window.Shopify?.globalVehicleFilter?.page_type === 'index' || location.pathname === (window.Shopify?.routes?.root || '/') || document.querySelector('[data-njh-finder]')) {
        current.searchParams.set(vehicleKey, vehicle.vehicleName);
        history.replaceState(history.state, '', current);
        window.globalVehicleFilter?.applyFilter(vehicle);
        document.dispatchEvent(new CustomEvent('njt:vehicle-state', { detail: vehicle }));
        document.querySelectorAll('.njh-dialog[open]').forEach(dialog => dialog.close());
        sync();
        const selected = document.querySelector('[data-njh-home-selected]');
        selected?.querySelector('[data-njh-current-title]')?.focus({preventScroll:true});
        return;
      }
      const target = current.pathname.includes('/collections/') ? current : new URL(link.getAttribute('href'), location.origin);
      target.searchParams.delete('page');
      target.searchParams.set(vehicleKey, vehicle.vehicleName);
      previewKeys.forEach(key => { if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key)); });
      location.assign(target.href);
    } finally { delete link.dataset.busy; link.removeAttribute('aria-busy'); }
  };
  const filterBrands = dialog => {
    const term = dialog.querySelector('[data-njh-search]').value.trim().toLocaleLowerCase();
    const letter = dialog.dataset.letter || '';
    let count = 0;
    dialog.querySelectorAll('[data-njh-item]').forEach(item => { const name = item.dataset.name; item.hidden = item.hasAttribute('data-njb-excluded') || !name.toLocaleLowerCase().includes(term) || Boolean(letter && !name.toUpperCase().startsWith(letter)); if (!item.hidden) count++; });
    dialog.querySelector('[data-njh-empty]').hidden = count > 0;
    dialog.querySelector('.njh-brand-featured').hidden = Boolean(term || letter);
  };
  const inGroup = (node, dialog) => (node.dataset.vehicleMake?.toUpperCase() === 'JEEP') === ((dialog.dataset.group || 'jeep') === 'jeep');
  const initMakes = dialog => {
    const grid = dialog.querySelector('.njh-makes');
    if (!grid || grid.dataset.ready) return;
    grid.dataset.ready = 'true';
    const grouped = new Map();
    dialog.querySelectorAll('[data-njh-model]').forEach(button => {
      const make = button.dataset.vehicleMake?.trim().toUpperCase();
      const name = button.dataset.name || button.textContent;
      const group = make === 'JEEP' ? 'jeep' : /hummer/i.test(make + ' ' + name) ? 'hummer' : '';
      if (!group) return;
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!grouped.has(group)) {
        grouped.set(group, panel);
        if (group === 'hummer') {
          button.dataset.name = 'HUMMER';
          button.querySelector('span').textContent = 'HUMMER';
          panel.querySelector('h3').textContent = 'HUMMER';
        }
      } else {
        panel.querySelectorAll('[data-njh-vehicle]').forEach(link => grouped.get(group).querySelector('.njh-vehicle-grid').append(link));
        panel.remove();
        button.remove();
      }
    });
    const models = [...dialog.querySelectorAll('[data-njh-model]')];
    const modelName = button => button.dataset.name || (button.dataset.vehicleMake + ' ' + button.textContent.trim());
    models.sort((a, b) => modelName(a).localeCompare(modelName(b), undefined, {numeric: true, sensitivity: 'base'}));
    models.forEach(button => dialog.querySelector('.njh-models').append(button));
    models.forEach(button => {
      const card = document.createElement('article');
      card.className = 'njh-model-card';
      button.before(card); card.append(button);
      const yearLabel = document.createElement('span');
      yearLabel.className = 'njh-select-year';
      yearLabel.textContent = dialog.dataset.selectYear || 'Select year';
      button.append(yearLabel);
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const links = [...panel.querySelectorAll('[data-njh-vehicle]')];
      const years = link => {
        const name = (link.dataset.vehicleName || '') + ' ' + (link.dataset.vehicleTitle || '');
        const dates = (name.match(/(?:19|20)\d{2}/g) || []).map(Number);
        return [/present|current|\d{4}\s*\+/i.test(name) ? 9999 : Math.max(0, ...dates), Math.min(...dates, 9999)];
      };
      links.sort((a,b) => years(b)[0] - years(a)[0] || years(b)[1] - years(a)[1] || (a.dataset.name || '').localeCompare(b.dataset.name || ''));
      links.forEach(link => panel.querySelector('.njh-vehicle-grid').append(link));
      const newest = links.find(link => link.querySelector('img'))?.querySelector('img');
      if (newest && button.querySelector('img')) button.querySelector('img').replaceWith(newest.cloneNode(true));
    });
  };
  const resetVehicles = (dialog, focus = false) => {
    dialog.dataset.group ||= 'jeep';
    initMakes(dialog);
    const makeGrid = dialog.querySelector('.njh-makes');
    makeGrid.hidden = true;
    makeGrid.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.njhMakeChoice === dialog.dataset.make)));
    const previous = dialog.querySelector('[data-njh-model][aria-expanded="true"]');
    dialog.querySelector('.njh-models').hidden = false;
    dialog.querySelector('[data-njh-back]').hidden = true;
    dialog.querySelectorAll('[data-njh-generations]').forEach(panel => { panel.hidden = true; dialog.querySelector('.njh-generation-panels').append(panel); });
    dialog.querySelectorAll('[data-njh-model]').forEach(button => { button.hidden = !inGroup(button, dialog); button.closest('.njh-model-card').hidden = button.hidden; button.setAttribute('aria-expanded', 'false'); });
    dialog.querySelectorAll('[data-njh-vehicle]').forEach(link => link.hidden = false);
    if (dialog.dataset.group === 'jeep') {
      dialog.querySelector('.njh-models').hidden = true;
      dialog.querySelectorAll('[data-njh-generations]').forEach(panel => { panel.hidden = ![...panel.querySelectorAll('[data-njh-vehicle]')].some(link => inGroup(link, dialog)); });
    }
    if (dialog.dataset.helpJeep) dialog.querySelector('.njh-help').textContent = dialog.dataset.group === 'jeep' ? dialog.dataset.helpJeep : dialog.dataset.helpOther;
    dialog.querySelector('[data-njh-empty]').hidden = true;
    if (focus) previous?.focus();
  };
  const desktopHover = matchMedia('(min-width:990px) and (hover:hover) and (pointer:fine)');
  let companyCloseTimer;
  const closeCompany = () => {
    clearTimeout(companyCloseTimer);
    const company = document.getElementById('Details-HeaderMenu-company');
    if (!company?.open) return;
    company.open = false;
    company.querySelector('summary').setAttribute('aria-expanded', 'false');
  };
  const open = (name, trigger, event) => {
    const drawer = trigger.closest('header-drawer');
    if (drawer?.closeMenuDrawer) drawer.closeMenuDrawer(event, false);
    const parts = document.querySelector('.njh-parts-source njt-parts-menu');
    const dialog = name === 'parts' ? parts?.querySelector('dialog') : document.getElementById('njh-' + name);
    if (!dialog || dialog.open) return;
    closeCompany();
    document.querySelectorAll('.njh-desktop-menu[open]').forEach(other => other.close());
    const desktop = Boolean(trigger.closest('.header__inline-menu')) && matchMedia('(min-width:990px) and (hover:hover)').matches;
    dialog.classList.toggle('njh-desktop-menu', desktop);
    if (desktop) {
      const position = () => {
        const zoom = parseFloat(getComputedStyle(document.body).zoom) || 1;
        const bottom = Math.max(0, trigger.closest('header').getBoundingClientRect().bottom);
        dialog.style.setProperty('--njh-menu-top', bottom / zoom + 'px');
        dialog.style.setProperty('--njh-menu-height', Math.max(0, (window.innerHeight - bottom - 10) / zoom) + 'px');
      };
      position();
      window.addEventListener('resize', position);
      window.addEventListener('scroll', position, {passive:true});
      dialog.addEventListener('close', () => {
        window.removeEventListener('resize', position);
        window.removeEventListener('scroll', position);
      }, {once:true});
    }
    sync();
    if (name === 'parts') {
      parts.open(!desktop);
      const vehicle = currentVehicle();
      const selected = vehicles().find(link => link.dataset.vehicleName === vehicle);
      parts.querySelector('[data-njp-vehicle-text]').textContent = selected?.dataset.vehicleTitle || vehicle || parts.dataset.allVehicles;
      if (selected?.querySelector('img')) { const photo = parts.querySelector('[data-njp-vehicle-image]'); photo.src = selected.querySelector('img').src; photo.hidden = false; parts.querySelector('[data-njp-jeep]').hidden = true; parts.querySelector('[data-njp-pickup]').hidden = true; }
      parts.querySelectorAll('[data-njp-link]').forEach(link => { link.href = route(link.dataset.base || link.getAttribute('href'), vehicle); });
    } else {
      if (name === 'vehicles') resetVehicles(dialog);
      dialog.querySelector('[data-njh-search]').value = '';
      if (name === 'brands') { dialog.dataset.letter = ''; dialog.querySelectorAll('[data-njh-letter]').forEach(button => button.setAttribute('aria-pressed', String(!button.dataset.njhLetter))); filterBrands(dialog); }
      if (desktop) dialog.show(); else dialog.showModal();
      if (!desktop) document.body.classList.add('njh-modal-open');
    }
    trigger.setAttribute('aria-expanded', 'true');
    dialog.addEventListener('close', () => {
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('njh-modal-open');
      const returnTo = drawer?.querySelector('summary') || trigger;
      if (!desktop) returnTo.focus({ preventScroll: true });
    }, { once: true });
  };
  let yearHoverTimer;
  document.addEventListener('pointerover', event => {
    const year = event.target.closest('.njh-select-year');
    if (!year || year.contains(event.relatedTarget) || !matchMedia('(min-width:750px) and (hover:hover) and (pointer:fine)').matches) return;
    const model = year.closest('[data-njh-model]');
    clearTimeout(yearHoverTimer);
    yearHoverTimer = setTimeout(() => {
      if (year.matches(':hover') && model?.getAttribute('aria-expanded') !== 'true') model.click();
    }, 140);
  });
  document.addEventListener('pointerout', event => {
    const year = event.target.closest('.njh-select-year');
    if (year && !year.contains(event.relatedTarget)) clearTimeout(yearHoverTimer);
  });
  let hoverTimer;
  document.addEventListener('pointerover', event => {
    if (event.target.closest('#Details-HeaderMenu-company')) clearTimeout(companyCloseTimer);
    const trigger = event.target.closest('.header__inline-menu [data-njh-open], .header__inline-menu #Details-HeaderMenu-company > summary');
    if (!trigger || !desktopHover.matches || event.pointerType === 'touch' || trigger.contains(event.relatedTarget)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => {
      if (!trigger.matches(':hover')) return;
      if (trigger.parentElement.id === 'Details-HeaderMenu-company') {
        document.querySelectorAll('.njh-desktop-menu[open]').forEach(dialog => dialog.close());
        trigger.parentElement.open = true;
        trigger.setAttribute('aria-expanded', 'true');
      } else open(trigger.dataset.njhOpen, trigger, event);
    }, 160);
  });
  document.addEventListener('pointerout', event => {
    const company = event.target.closest('#Details-HeaderMenu-company');
    if (!company || company.contains(event.relatedTarget) || !desktopHover.matches) return;
    clearTimeout(companyCloseTimer);
    companyCloseTimer = setTimeout(() => {
      if (!company.matches(':hover') && !(company.contains(document.activeElement) && document.activeElement.matches(':focus-visible'))) closeCompany();
    }, 220);
  });
  document.addEventListener('pointerdown', event => {
    if (!event.target.closest('.njh-desktop-menu, [data-njh-open]')) document.querySelectorAll('.njh-desktop-menu[open]').forEach(dialog => dialog.close());
    if (!event.target.closest('#Details-HeaderMenu-company')) closeCompany();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    clearTimeout(hoverTimer);
    document.querySelectorAll('.njh-desktop-menu[open]').forEach(dialog => dialog.close());
    const company = document.getElementById('Details-HeaderMenu-company');
    const returnFocus = company?.open && company.contains(document.activeElement);
    closeCompany();
    if (returnFocus) company.querySelector('summary').focus({preventScroll:true});
  });
  desktopHover.addEventListener('change', () => {
    clearTimeout(hoverTimer);
    closeCompany();
  });
  document.addEventListener('click', event => {
    if (event.target.closest('#Details-HeaderMenu-company > summary')) {
      clearTimeout(hoverTimer);
      document.querySelectorAll('.njh-desktop-menu[open]').forEach(dialog => dialog.close());
    }
    const trigger = event.target.closest('[data-njh-open]');
    if (trigger) { event.preventDefault(); open(trigger.dataset.njhOpen, trigger, event); return; }
    const close = event.target.closest('[data-njh-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('dialog.njh-dialog')) { const rect = event.target.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close(); }
    const letter = event.target.closest('[data-njh-letter]');
    if (letter) { const dialog = letter.closest('dialog'); dialog.dataset.letter = letter.dataset.njhLetter; dialog.querySelectorAll('[data-njh-letter]').forEach(button => button.setAttribute('aria-pressed', String(button === letter))); filterBrands(dialog); }
    const group = event.target.closest('[data-njh-group]');
    if (group) { const dialog = group.closest('dialog'); dialog.dataset.group = group.dataset.njhGroup; delete dialog.dataset.make; dialog.querySelectorAll('[data-njh-group]').forEach(b => b.setAttribute('aria-pressed', String(b === group))); dialog.querySelector('[data-njh-search]').value = ''; resetVehicles(dialog); }
    const makeChoice = event.target.closest('[data-njh-make-choice]');
    if (makeChoice) {
      const dialog = makeChoice.closest('dialog');
      dialog.dataset.make = dialog.dataset.make === makeChoice.dataset.njhMakeChoice ? '' : makeChoice.dataset.njhMakeChoice;
      dialog.querySelector('[data-njh-search]').value = '';
      resetVehicles(dialog);
    }
    const model = event.target.closest('[data-njh-model]');
    if (model) { const dialog = model.closest('dialog'); const wasOpen = model.getAttribute('aria-expanded') === 'true'; resetVehicles(dialog); if (!wasOpen) { model.setAttribute('aria-expanded', 'true'); const panel = document.getElementById(model.getAttribute('aria-controls')); model.closest('.njh-model-card').append(panel); panel.hidden = false; } }
    const back = event.target.closest('[data-njh-back]');
    if (back) { const dialog = back.closest('dialog'); dialog.querySelector('[data-njh-search]').value = ''; resetVehicles(dialog, true); }
    const vehicle = event.target.closest('[data-njh-vehicle]');
    if (vehicle && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) { event.preventDefault(); choose(vehicle); }
    const clear = event.target.closest('[data-njh-clear]');
    if (clear) { document.querySelectorAll('.njh-dialog[open]').forEach(dialog => dialog.close()); window.globalVehicleFilter?.clearFilter(); }
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-njh-search]')) return;
    const dialog = event.target.closest('dialog');
    if (dialog.id === 'njh-brands') { filterBrands(dialog); return; }
    resetVehicles(dialog);
    const term = event.target.value.trim().toLocaleLowerCase();
    if (!term) return;
    const matchesTerm = link => ((link.dataset.name || '') + ' ' + (link.dataset.vehicleMake || '')).toLocaleLowerCase().includes(term);
    const matchingVehicles = [...dialog.querySelectorAll('[data-njh-vehicle]')].filter(matchesTerm);
    if (matchingVehicles.length && !matchingVehicles.some(link => inGroup(link, dialog))) {
      dialog.dataset.group = matchingVehicles[0].dataset.vehicleMake?.toUpperCase() === 'JEEP' ? 'jeep' : 'other';
      delete dialog.dataset.make;
      dialog.querySelectorAll('[data-njh-group]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.njhGroup === dialog.dataset.group)));
      resetVehicles(dialog);
    }
    let count = 0;
    dialog.querySelector('.njh-makes').hidden = true;
    dialog.querySelector('.njh-models').hidden = true;
    dialog.querySelectorAll('[data-njh-generations]').forEach(panel => { let matches = 0; panel.querySelectorAll('[data-njh-vehicle]').forEach(link => { link.hidden = !inGroup(link, dialog) || !matchesTerm(link); if (!link.hidden) matches++; }); panel.hidden = !matches; count += matches; });
    dialog.querySelector('[data-njh-empty]').hidden = count > 0;
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const dialog = event.target.closest('dialog.njh-dialog');
    if (dialog?.open) { event.preventDefault(); event.stopPropagation(); dialog.close(); }
  }, true);
  const init = () => {
    sync();
    document.querySelectorAll('[data-njh-finder]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const make = form.querySelector('[data-njh-make]'), choice = form.querySelector('[data-njh-choice]'), model = form.querySelector('[data-njh-model-choice]'), submit = form.querySelector('[type="submit"]');
      make.addEventListener('change', () => {
        model.replaceChildren(model.options[0]); choice.replaceChildren(choice.options[0]);
        [...new Set(vehicles().filter(link => link.dataset.vehicleMake === make.value).map(link => link.dataset.vehicleModel))].sort().forEach(name => model.add(new Option(name, name)));
        model.value = ''; model.disabled = !make.value; choice.value = ''; choice.disabled = true; submit.disabled = true;
      });
      model.addEventListener('change', () => {
        choice.replaceChildren(choice.options[0]);
        vehicles().filter(link => link.dataset.vehicleMake === make.value && link.dataset.vehicleModel === model.value).forEach(link => choice.add(new Option(link.dataset.vehicleTitle, link.dataset.vehicleName)));
        choice.value = ''; choice.disabled = !model.value; submit.disabled = true;
      });
      choice.addEventListener('change', () => submit.disabled = !choice.value);
      form.addEventListener('submit', event => { event.preventDefault(); choose(vehicles().find(link => link.dataset.vehicleName === choice.value)); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('njt:vehicle-state', sync);
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-njt-shop-parts]')) return;
    const parts = document.getElementById('shop-offroad-parts');
    if (!parts) return;
    event.preventDefault();
    const heading = parts.querySelector('h2');
    if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({preventScroll:true}); }
    const header = document.querySelector('.section-header') || document.querySelector('header');
    const offset = (header?.getBoundingClientRect().height || 0) + 20;
    window.scrollTo({top:Math.max(0, parts.getBoundingClientRect().top + window.scrollY - offset), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
  window.addEventListener('popstate', sync);
})();

